module.exports = __webpack_public_path__ + "img/hero_form.9dfdee91.png";